"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextboxPropertySelector = void 0;
var textbox_property_selector_1 = require("./textbox-property-selector");
Object.defineProperty(exports, "createTextboxPropertySelector", { enumerable: true, get: function () { return textbox_property_selector_1.createTextboxPropertySelector; } });
//# sourceMappingURL=index.js.map